import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.animate-hr').forEach(hr => {

  ScrollTrigger.create({
    trigger: hr,
    start: 'top 60%',
    end: 'center center',
    once: true,
    onEnter: () => {
      gsap.to(hr, { width: '100%', opacity:0.35, duration: 0.8, ease: 'power1.out' });
    }
  });

});

gsap.utils.toArray('.document-item, .anchor-container a').forEach(item => {
  const hoverHr = item.querySelector('.hover-hr');

  item.addEventListener('mouseenter', () => {
    gsap.to(hoverHr, { width: '100%', opacity: 0.8, duration: 0.8, ease: 'power1.out' });
  });

  item.addEventListener('mouseleave', () => {
    gsap.to(hoverHr, { width: '0', opacity: 0.5, duration: 0.8, ease: 'power1.out' });
  });
});
